import { get } from "helpers/api_helper";
import { ADMIN_EMAIL_VALIDATION } from 'helpers/url_helper';

const asyncValidate = async function (values, dispatch, props, field) {
    if (field) {
        const index = new Number(field.replace(/\D/g, ''));

        if (!values.users || !values.users[index] || !values.users[index].email) {
            return Promise.resolve();
        }

        return get(ADMIN_EMAIL_VALIDATION, { params: { mail: values.users[index].email } })
            .then(({ exists }) => {
                if (exists) throw {
                    users: {
                        [index]: { email: 'The email has already been added to contacts' }
                    }
                };
            });
    } else {
        return new Promise(async (resolve, reject) => {
            if (!values.users || !values.users.length) {
                resolve();
            } else {
                let users = {}, index = 0;
                for (const user of values.users) {
                    if (user.email) {
                        const { exists } = await get(ADMIN_EMAIL_VALIDATION, { params: { mail: user.email } });
                        if (exists) {
                            users = {
                                ...users,
                                [index]: { email: 'The email has already been added to contacts' }
                            }
                        }
                    }
                    index++;
                }
                if (Object.keys(users).length) {
                    reject({ users });
                } else {
                    resolve();
                }
            }
        });
    }
};

export default (asyncValidate);